import { type SVGProps } from 'react';

export function WifiOff(props: Readonly<SVGProps<SVGSVGElement>>) {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}>
            <path
                d='M10 15.4166H10.0098'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.0835 12.9166C8.4407 11.5594 10.4185 11.3074 12.0835 12.1606'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.5835 10.4167C5.8335 9.16659 7.0224 8.62792 8.3335 8.33325'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.4167 10.4168C14.1728 9.31631 12.7373 8.56188 11.25 8.33337'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.6665 7.91666C2.9165 6.66675 4.13432 5.96876 5.4165 5.41675'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.3332 7.91661C15.0596 5.15232 11.4467 4.10737 7.9165 4.78177'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M1.6665 1.66663L18.3332 18.3333'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
            />
        </svg>
    );
}
